export default "__VITE_ASSET__82f61b48__"